import type {AllowMediaChangeOfDirection} from '@pexip/infinity';
import {ClientCallType} from '@pexip/infinity/clientCallType';
import type {MediaDeviceRequest} from '@pexip/media-control';

import {config} from '../config';

export const changeCallTypeSendDirection = (
    constraints: MediaDeviceRequest,
    currentCallType: ClientCallType,
    allow: AllowMediaChangeOfDirection,
): ClientCallType => {
    let callType = currentCallType;
    if (allow.audio && constraints.audio !== undefined) {
        if (constraints.audio) {
            callType |= ClientCallType.AudioSend;
        } else {
            callType &= ~ClientCallType.AudioSend;
        }
    }
    if (allow.video && constraints.video !== undefined) {
        if (constraints.video) {
            callType |= ClientCallType.VideoSend;
        } else {
            callType &= ~ClientCallType.VideoSend;
        }
    }
    return callType;
};

/**
 * Apply the update to current callType config based on the result
 * of `changeCallTypeSendDirection`
 *
 * @param constraints - The constraints to check
 * @param persist - Whether to persist the change or not
 * @defaultValue `false`
 * @return `true` means changed, `false` otherwise
 */
export const applyCallTypeSendDirectionChange = (
    constraints: MediaDeviceRequest,
    persist = false,
): boolean => {
    const nextCallType = changeCallTypeSendDirection(
        constraints,
        config.get('callType'),
        config.get('allowChangeOfMediaDirection'),
    );
    if (nextCallType !== config.get('callType')) {
        config.set({
            key: 'callType',
            value: nextCallType,
            persist,
        });
        return true;
    }
    return false;
};
